/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * VSD API
 * API for the Victim Services Directory (VSD) application
 * OpenAPI spec version: v1
 */

export type GetApiLookupCitiesSearchParams = {
  country?: string;
  province?: string;
  searchVal?: string;
  limit?: number;
};
